<template>
  <div :class="['widget', {'border-error': error}]">

    <template v-if="loading">
      <v-layout
        align-center
        justify-center
        fill-height>
        <v-progress-circular
          size="50"
          indeterminate/>
      </v-layout>
    </template>

    <template v-else>
      <v-container>
        <v-layout justify-space-between>
          <span class="title">
            {{ $route.params.id }}
          </span>
          <span v-if="site.bsSerial">
            {{ site.bsSerial | formatBsSerial }}
          </span>
          <span
            v-else
            style="color: grey;">
            Unknown base station ID
          </span>
        </v-layout>
        <v-layout
          v-if="site.address"
          class="caption">
          <v-flex grow>
            <div>{{ site.address.street }}</div>
            <div>
              {{ site.address.suburb }},
              {{ site.address.postCode }}
              <b>{{ site.address.state }}</b>
            </div>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          class="caption">
          <v-flex md4>
            <div style="color: grey;">Unknown address</div>
          </v-flex>
        </v-layout>
      </v-container>
    </template>

  </div>
</template>

<script>
export default {
  name: "id",
  data () {
    return {
      error: false,
      loading: true,
      site: {}
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}`).
      then((r) => this.site = r.data).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Id.vue